import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";
import { queryKeys } from "./queryKeys";

const fetchOrganizationDetails = async () => {
  const response = await api.get("/department-info/organisation-details");
  return response?.data?.data ?? response?.data;
};

export const useOrganizationDetails = () => {
  return useQuery({
    queryKey: queryKeys.organization.details(),
    queryFn: fetchOrganizationDetails,
    staleTime: 10 * 60 * 1000, // 10 min cache so page loads fast on revisit
    placeholderData: (previousData) => previousData, // keep previous data while refetching
  });
};
